module.exports = __webpack_public_path__ + "img/Monthly Add Shift.82e60641.png";